import Breakpoint from "@core/scripts/helper/breakpoint.js";
import {ImageTypes} from "./image-types.js";
import {RecommendationTypes} from "./recommendation-types.js";

const SCROLL_OFFSET = 30;

const SLIDER_PARAM = 'slider';

function navigateToTargetWithRecommendationTypeOrigin(type, target) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set(SLIDER_PARAM, type);

    history.replaceState({}, "", window.location.href.split('?')[0] + '?' + urlParams.toString());

    window.location = target;
}

function scrollToSliderOnBrowserBack(type, sliderNode) {
    const observer = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
            if (entry.type === "back_forward") {
                const urlParams = new URLSearchParams(window.location.search);
                const headerHeight = document.querySelector('[jsh-header]')?.offsetHeight;
                const currentScrollOffset = Breakpoint.keyIsIn(['small', 'medium']) ? SCROLL_OFFSET + headerHeight : SCROLL_OFFSET;
                if (urlParams.get(SLIDER_PARAM) === type) {
                    window.scrollTo(0, sliderNode?.offsetTop - currentScrollOffset);

                    urlParams.delete(SLIDER_PARAM);
                    const urlQueryString = Array.from(urlParams).length > 0 ? '?' + urlParams.toString() : '';
                    history.replaceState({}, "", window.location.href.split('?')[0] + urlQueryString);
                }
            }
        });
    });

    observer.observe({ type: "navigation", buffered: true });
}

function getRecommendationType(key) {
    if (key === 'productSeries') {
        return RecommendationTypes.PRODUCT_SERIES;
    }
    if (key === 'shopTheLook') {
        return RecommendationTypes.SHOP_THE_LOOK;
    }
    if (key === 'outfits') {
        return RecommendationTypes.OUTFITS;
    }
    if (key === 'boughtTogether') {
        return RecommendationTypes.BOUGHT_TOGETHER;
    }
    if (key === 'complementaryArticles') {
        return RecommendationTypes.COMPLEMENTARY_ARTICLES;
    }
    if (key === 'thorOutfit') {
        return RecommendationTypes.THOR_OUTFIT;
    }
    return null;
}

function getNumberOfItemsPerPage(breakpoints) {
   return breakpoints.find(bp => window.innerWidth >= bp.minWidth)?.items;
}

function calculateCarouselPadding(numberOfItemsPerPage, slideCut) {
    const viewPortWidth = window.innerWidth;
    const visibleItems = numberOfItemsPerPage + 0.5;
    const itemWidth = viewPortWidth / visibleItems;
    return itemWidth * slideCut;
}

export default {
    navigateToTargetWithRecommendationTypeOrigin,
    scrollToSliderOnBrowserBack,
    getRecommendationType,
    getNumberOfItemsPerPage,
    calculateCarouselPadding
}
